<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>微信商城</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入商品名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Uuidspeciesname" label="商品分类" width="150px"></el-table-column>
          <el-table-column prop="Uuidgoods" label="商品编号" width="200px"></el-table-column>
          <el-table-column prop="Name" label="商品名称" width="200px"></el-table-column>
          <el-table-column prop="Money" label="商品金额" width="200px"></el-table-column>
          <el-table-column prop="Images" label="商品图标" width="200px">
            <template slot-scope="scope">
              <img :src="scope.row.Imageb" min-width="48" height="48" />
            </template>
          </el-table-column>
          <el-table-column prop="Statusname" label="商品上架状态" width="200px"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 0" @click="clickShangJia(scope.row)">上架</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1" @click="clickXiaJia(scope.row)">下架</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加商品 start -->
      <el-tab-pane label="添加商品" name="second">
        <el-form :model="addForm" ref="addFormRef" label-width="75px">
          <el-form-item label="商品分类">
            <el-select v-model="addForm.uuidspecies" placeholder="请选择" class="select">
              <el-option
                v-for="item in wxstorespecies" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名称" class="addAdminForm">
            <el-input v-model="addForm.name" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="商品金额" class="addAdminForm">
            <el-input v-model="addForm.money" placeholder="请输入商品金额"></el-input>
          </el-form-item>
          <el-form-item label="大图标" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.imageb" @change="addTencentyunCosUploadImgb"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="小图标" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.images" @change="addTencentyunCosUploadImgs"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="横屏图1" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.image1" @change="addTencentyunCosUploadImg1"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="横屏图2" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.image2" @change="addTencentyunCosUploadImg2"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="横屏图3" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.image3" @change="addTencentyunCosUploadImg3"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="信息图" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.imagemain" @change="addTencentyunCosUploadImgmain"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加商品 end -->

      <!-- 编辑商品 start -->
      <el-tab-pane label="编辑商品" name="three" v-if="displaythree">
        <el-form :model="editForm" ref="editFormRef" label-width="75px">
          <el-form-item label="商品分类">
            <el-select v-model="editForm.uuidspecies" placeholder="请选择" class="select">
              <el-option
                v-for="item in wxstorespecies" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名称" class="addAdminForm">
            <el-input v-model="editForm.name" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="商品金额" class="addAdminForm">
            <el-input v-model="editForm.money" placeholder="请输入商品金额"></el-input>
          </el-form-item>
          <el-form-item label="大图标" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.imageb" @change="addTencentyunCosUploadImgb"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="小图标" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.images" @change="addTencentyunCosUploadImgs"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="横屏图1" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.image1" @change="addTencentyunCosUploadImg1"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="横屏图2" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.image2" @change="addTencentyunCosUploadImg2"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="横屏图3" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.image3" @change="addTencentyunCosUploadImg3"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="信息图" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.imagemain" @change="addTencentyunCosUploadImgmain"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="postEdit">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 编辑商品 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import TencentyunCosUploadImg from '@/components/TencentyunCosUploadImg.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    TencentyunCosUploadImg
  },
  name: 'MyWxStoreGoods',
  data () {
    return {
      activeName: 'first',
      wxstorespecies: [],
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        name: ''
      },
      // 添加
      addForm: {
        uuidspecies: '60',
        uuidgoods: '',
        name: '',
        money: '',
        imageb: '',
        images: '',
        image1: '',
        image2: '',
        image3: '',
        imagemain: ''
      },
      editForm: {
        id: '',
        uuidspecies: '',
        name: '',
        money: '',
        imageb: '',
        images: '',
        image1: '',
        image2: '',
        image3: '',
        imagemain: ''
      },
      displaythree: false
    }
  },
  mounted () {
    this.apiGetWxstoreSpeciesList()
    this.apiGetWxstoreGoodsNum()
    this.apiGetWxstoreGoodsList()
  },
  methods: {
    addTencentyunCosUploadImgb (url) {
      this.addForm.imageb = url
      this.editForm.imageb = url
    },
    addTencentyunCosUploadImgs (url) {
      this.addForm.images = url
      this.editForm.images = url
    },
    addTencentyunCosUploadImg1 (url) {
      this.addForm.image1 = url
      this.editForm.image1 = url
    },
    addTencentyunCosUploadImg2 (url) {
      this.addForm.image2 = url
      this.editForm.image2 = url
    },
    addTencentyunCosUploadImg3 (url) {
      this.addForm.image3 = url
      this.editForm.image3 = url
    },
    addTencentyunCosUploadImgmain (url) {
      this.addForm.imagemain = url
      this.editForm.imagemain = url
    },
    clickreturn () {
      this.activeName = 'first'
      this.displaythree = false
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetWxstoreGoodsList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetWxstoreGoodsNum()
      this.apiGetWxstoreGoodsList()
    },
    clickadd () {
      var timestamp = (new Date()).valueOf()
      this.addForm.uuidgoods = timestamp
      this.apiAddWxstoreGoods()
    },
    clickEdit (row) {
      this.editForm.id = row.Id
      this.editForm.uuidspecies = row.Uuidspecies
      this.editForm.name = row.Name
      this.editForm.money = row.Money
      this.editForm.imageb = row.Imageb
      this.editForm.images = row.Images
      this.editForm.image1 = row.Image1
      this.editForm.image2 = row.Image2
      this.editForm.image3 = row.Image3
      this.editForm.imagemain = row.Imagemain

      this.displaythree = true
      this.activeName = 'three'
    },
    postEdit () {
      this.apiEditWxstoreGoods()
    },
    //
    clickShangJia (row) {
      this.$confirm('是否上架该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiShangXiaJiaWxstoreGoods(row.Id, '1')
      })
    },
    clickXiaJia (row) {
      this.$confirm('是否下架该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiShangXiaJiaWxstoreGoods(row.Id, '0')
      })
    },
    apiGetWxstoreSpeciesList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWxstoreSpeciesList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.wxstorespecies = []
            response.data.List.filter((item1, i1) => {
              that.wxstorespecies.push({ value: item1.Uuidspecies, label: item1.Name })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWxstoreGoodsList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWxstoreGoodsList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWxstoreGoodsNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWxstoreGoodsNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddWxstoreGoods: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        uuidspecies: that.addForm.uuidspecies,
        uuidgoods: that.addForm.uuidgoods,
        name: that.addForm.name,
        money: that.addForm.money,
        imageb: that.addForm.imageb,
        images: that.addForm.images,
        image1: that.addForm.image1,
        image2: that.addForm.image2,
        image3: that.addForm.image3,
        imagemain: that.addForm.imagemain
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddWxstoreGoods, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetWxstoreGoodsNum()
            that.apiGetWxstoreGoodsList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditWxstoreGoods: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        uuidspecies: that.editForm.uuidspecies,
        name: that.editForm.name,
        money: that.editForm.money,
        imageb: that.editForm.imageb,
        images: that.editForm.images,
        image1: that.editForm.image1,
        image2: that.editForm.image2,
        image3: that.editForm.image3,
        imagemain: that.editForm.imagemain
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditWxstoreGoods, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.displaythree = false
            that.apiGetWxstoreGoodsNum()
            that.apiGetWxstoreGoodsList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShangXiaJiaWxstoreGoods: function (id, status) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id,
        status: status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShangXiaJiaWxstoreGoods, Qs.stringify(data))
        .then(function (response) {
          that.apiGetWxstoreGoodsNum()
          that.apiGetWxstoreGoodsList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
